import { BuchungService } from './../../api/buchung.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Buchung } from 'src/app/api/buchung';

@Component({
  selector: 'app-buchung',
  templateUrl: './buchung.component.html',
  styleUrls: ['./buchung.component.scss']
})
export class BuchungComponent implements OnInit {
  public buchung: Buchung;
  
  constructor(private route: ActivatedRoute, private buchungService: BuchungService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      let buchungId: number = params['buchung'];
      this.buchungService.getBuchung(buchungId).subscribe(
        (result) => {
          if (!!result) {
            this.buchung = result;
          }
        }
      )
    })
  }

}
